import React from "react";

import "./Logo.scss";

function Logo() {
  return <div className="Logo">Local Gift</div>;
}

export default Logo;
